<template>
  <div>
    <div v-if="page === 'pick-test'">
      <div class="content-av-text text-sm">
        <div class="row">
          <div class="col-sm-7">
            <p v-html="translate('create-subtest-attempt.description_line_1')">
            </p>
            <p v-html="translate('create-subtest-attempt.description_line_2')">
            </p>
            <p v-html="translate('create-subtest-attempt.description_line_3')">
            </p>
            <p v-html="translate('create-subtest-attempt.description_line_4')">
            </p>
          </div>
          <div class="col-sm-5">
            <p>
              <img src="/images/ppn.jpg" alt="content">
            </p>
          </div>
        </div>
      </div>
      <div class="margin-style">
        <h3 class="title-style">{{ translate('create-subtest-attempt.select_test_level') }}</h3>

        <div class="filter-block">
          <div class="filter-block-title">
            {{ translate('create-subtest-attempt.select_test_level_label') }}
          </div>
          <ul class="filter-block-list">
            <li v-for="testType in testTypes">
              <label class="radio-style-wrap" @click="selectTestType(testType)">
                <img :src="testType.icon_path" :alt="testType.name">
                <input type="radio" :id="testType" :value="testType" v-model="selectedTestType">
                <span class="radio-style"></span>
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div class="margin-style" v-if="subtests.length > 0">
        <div v-if="showTestVariationSelector">
          <h4 class="title-style mt-5">{{ translate('create-subtest-attempt.select_test_variation') }}</h4>

          <ul class="nav nav-pills">
            <li v-for="testVariation in testVariations"
                class="nav-item"
                v-if="subtestHasVariations(testVariation)">
              <a class="nav-link" :class="testVariation.id === 1 ? 'active' : ''"
                 :href="'#test-variation' + testVariation.id"
                 data-toggle="tab" role="tab" :aria-controls="'#test-variation' + testVariation.id">
                {{ variationName(testVariation) }}
              </a>
            </li>
          </ul>
        </div>

        <h4 class="title-style mt-5">{{ translate('create-subtest-attempt.select_subtest') }}</h4>

        <div class="tab-content" id="nav-tabContent">
          <div v-for="testVariation in testVariations" class="tab-pane fade"
               :class="testVariation.id === 1 ? 'show active' : ''"
               :id="'test-variation' + testVariation.id"
               role="tabpanel">
            <div class="one-product shadow-sm"
                 v-for="subtest in subtests.filter(subtest => subtest.test_variation_id === testVariation.id)">
              <subtest :subtest="subtest"></subtest>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="page === 'pick-time-slot'">
      <div class="content-av-text text-sm margin-style2" v-if="selectedSubtest">
        <div class="row">
          <div class="col-sm-3">
            <p>
              <img :src="selectedTestType.icon_path" :alt="selectedTestType.name">
            </p>
          </div>
          <div class="col-sm-8">
            <icons :subtest="selectedSubtest"></icons>
            <p>
              {{ translate('create-subtest-attempt.subtest.' + selectedSubtest.subtest_type.name + '_description') }}
            </p>
          </div>
        </div>
      </div>
      <calendar :setting="setting" :booked-slots="bookedSlots"></calendar>

      <br>

      <div class="row">
        <div class="col-sm-5">
          <div class="form-group">
            <label for="platform">
              <span class="text-sm">{{ translate('create-subtest-attempt.platform') }}</span>
            </label>
            <select id="platform" name="platform" class="form-control"
                    v-model="createSubtestAttemptForm.platform">
              <option value="skype">Skype</option>
              <option value="zoom">Zoom</option>
              <option value="jitsi-meet">Jitsi Meet</option>
              <option value="meet-google">Meet Google</option>
              <option value="invitation">{{ translate('create-subtest-attempt.platform_invitation') }}</option>
            </select>
          </div>
        </div>

        <div class="col-sm-5">
          <div class="form-group" v-if="createSubtestAttemptForm.platform !== 'invitation'">
            <label for="platform_id">
              <span class="text-sm">Link / User</span>
            </label>
            <input id="platform_id" type="text" name="platform_id"
                   v-model="createSubtestAttemptForm.platform_id" class="form-control">
          </div>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary float-right create-subtest-attempt"
                  :disabled="!createSubtestAttemptForm.speaking_appointment_at"
                  @click="createSubtestAttempt">
            {{ translate('create-subtest-attempt.next') }} <i class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>

      <div class="alert alert-info">
        <span class="fa fa-info-circle"></span>{{ translate('create-subtest-attempt.platform_note') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['testType', 'testVariations', 'setting', 'bookedSlots'],

  mixins: [require('../../../../resources/js/mixin')],

  /**
   * The component's data.
   */
  data () {
    return {
      page: 'pick-test',
      subtests: [],

      selectedTestType: null,
      selectedSubtest: null,

      createSubtestAttemptForm: new AppForm({
        _token: App.csrfToken,
        subtest: null,
        speaking_appointment_at: null,
        platform: null,
        platform_id: null
      }),
    };
  },

  created () {
    this.$on('selectSubtest', function (subtest) {
      this.selectSubtest(subtest);
    });

    this.$on('selectDate', function (date) {
      this.createSubtestAttemptForm.speaking_appointment_at = moment(date).format('YYYY-MM-DD HH:mm:ss');
    });

    if (this.testType) {
      this.selectTestType(App.test_types.find(testType => testType.name === this.testType));
    }
  },

  computed: {
    testTypes () {
      return App.test_types;
    },

    showTestVariationSelector () {
      return this.subtests.filter(subtest => [2, 3, 4].includes(subtest.test_variation_id)).length > 0;
    },
  },

  methods: {
    createSubtestAttempt () {
      let self = this;

      App.post('/api/subtest-attempts', this.createSubtestAttemptForm)
        .then(() => {
          self.createSubtestAttemptForm.subtest = null;
          self.createSubtestAttemptForm.speaking_appointment_at = null;
          self.createSubtestAttemptForm.platform = null;
          self.createSubtestAttemptForm.platform_id = null;

          window.location.href = '/invoices/create';
        });
    },

    subtestHasVariations (testVariation) {
      return this.subtests.filter(subtest => subtest.test_variation_id === testVariation.id).length > 0;
    },

    variationName (testVariation) {
      let variationLine = testVariation.id === 1 ? '' : '/ ' + testVariation['title_' + App.locale];
      let testVariationTestTypePivot = testVariation.test_types.find(testType => testType.id === this.selectedTestType.id);
      let age = testVariationTestTypePivot ? testVariationTestTypePivot.pivot.age : null;
      let ageLine = age ? '(' + this.translate('create-subtest-attempt.from') + ' ' + age + ' ' + this.translate('create-subtest-attempt.years') + ')' : '';

      return this.selectedTestType.title + ' ' + variationLine + ' ' + ageLine;
    },

    selectTestType (testType) {
      if (this.selectedTestType && this.selectedTestType.id === testType.id) {
        return;
      }

      this.selectedTestType = testType;
      this.getSubtests(testType);
    },

    selectSubtest (subtest) {
      this.selectedSubtest = subtest;
      this.createSubtestAttemptForm.subtest = subtest.id;

      if (this.selectedSubtest.subtest_type_id === 3) {
        this.createSubtestAttempt();
      } else {
        this.page = 'pick-time-slot';
      }
    },

    getSubtests (testType) {
      let self = this;

      axios.get('/api/subtests?test_type=' + testType.id)
        .then(function (response) {
          self.subtests = response.data.subtests;
        });
    },
  }
};
</script>

<style>
.filter-block-list li {
    width: 40px;
}

.radio-style-wrap {
    cursor: pointer;
}

.one-product {
    border: none !important;
    margin-bottom: 40px;
    border-radius: 4px;
}

.create-subtest-attempt {
    margin-top: 33px;
}
</style>
